module.exports = __webpack_public_path__ + "img/p159.6a110434.png";